import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

interface Props {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: Props) => {
  const { status } = useAuth();

  if (status === "loading") {
    return <p>Loading session...</p>;
  }

  return status === "authenticated" ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
